import React, { useEffect, useState, useRef } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import sales from "../../../Data/sales.json";
import customers from "../../../Data/customers.json";
import toast from "react-hot-toast";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_transfer_reports } from "../../../Controllers/Dashboard/Dashboard";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

const TransferReports = () => {
  let location = useLocation();
  let componentRef = useRef();  

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();

  const headers = {
    name: "Invoices",
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        allowClear: true,
        showSearch: false,
        filterOption: true,
        value: null,
        options: [
          { value: 0, label: "Price (Low-High)" },
          { value: 1, label: "Price (High-Low)" },
        ],
      },
      {
        type: "filter",
        name: "supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branches",
        api: "get-all-sub-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "status",
        placeholder: "Status",
        value: null,
        allowClear: true,
        showSearch: false,
        filterOption: true,
        options: [
          { value: 0, label: "Inactive" },
          { value: 1, label: "Active" },
        ],
      },
      {
        type: "range",
        name: "date",
        value: {
          start: new Date(),
          end: new Date(),
        },
      },
      {
        type: "range",
        name: "due_date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        supplier: tabledata?.supplier,
        branch: tabledata?.branch,
        status: tabledata?.status,
        date: tabledata?.date,
        due_date: tabledata?.due_date,
      };

      const products = await get_transfer_reports(data);
      if (products?.status) {
        setBody(products?.data);
        setLoader(false);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div>
          <div className="text-right pb-4">
            <ReactToPrint
              trigger={() => (
                <Button
                  className="bg-white border rounded hover:border-green-500 w-36"
                  type="button"
                  size="large"
                >
                  Print <PrinterOutlined className="text-lg" />
                </Button>
              )}
              content={() => componentRef}
              pageStyle={`
                @page {
                  size: landscape;
                  margin: 10mm;
                  @bottom-right {
                    content: " " counter(page) " of " counter(pages);
                    font-size: 10px;
                  }
                }
              `}
            />
          </div>
        </div>
        <table className="w-full bg-white" ref={(el) => (componentRef = el)}>
          <thead className="text-gray-500">
            <tr>
              <td className="border p-4">Transfer</td>
              {/* <td className="border p-4">Customer</td> */}
              <td className="border p-4">Branch</td>
              <td className="border p-4">Date</td>
              {/* <td className="border p-4">Cash</td>
              <td className="border p-4">Debit</td>
              <td className="border p-4">Credit</td>
              <td className="border p-4">Bank</td>
              <td className="border p-4">Online</td>
              <td className="border p-4">Cheque</td>
              <td className="border p-4">Paid</td>
              <td className="border p-4">Payable</td> */}
              <td className="border p-4">Subtotal</td>
              <td className="border p-4">Tax&nbsp;[VAT]</td>
              <td className="border p-4">Total</td>
            </tr>
          </thead>
          <tbody>
            {body?.map((value, index) => {
              return (
                <tr>
                  <td className="border p-4">#TR-{value?.number}</td>
                  {/* <td className="border p-4">{value?.customer?.name}</td> */}
                  <td className="border p-4">{value?.supplier?.name}</td>
                  <td className="border p-4">
                    {value?.date
                      ? moment?.(value?.date)?.format?.("DD-MM-YYYY")
                      : ""}
                  </td>
                  {/* <td className="border p-4">
                    {value?.total_cash?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.total_debit_card?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.total_credit_card?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.total_bank_transfer?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.total_online_payment?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.total_cheque?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.total_paid?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.total_payable?.toFixed?.(3)}
                  </td> */}
                  <td className="border p-4">
                    {value?.subtotal?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">
                    {value?.taxamount?.toFixed?.(3)}
                  </td>
                  <td className="border p-4">{value?.total?.toFixed?.(3)}</td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4"></td>
            <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.subtotal),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.taxamount),
                  0
                )
                ?.toFixed(3)}
            </td>
            <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.total),
                  0
                )
                ?.toFixed(3)}
            </td>
          </tfoot>
        </table>
      </Loadercomponent>
    </Header>
  );
};

export default TransferReports;
